import { ChangeDetectorRef, Component, EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment-timezone';
import { error } from 'pdf-lib';
import { debounceTime, forkJoin, map, Subject } from 'rxjs';
import { CalculateFareModalComponent } from 'src/app/components/slideouts/calculate-fare-modal/calculate-fare-modal.component';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { StagingTripService } from 'src/app/services/core/distributions/staging-trip/staging-trip.service';
import { PlacetypesService } from 'src/app/services/core/placetypes/placetypes.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { roundUp } from 'src/app/utils/common.utils';
import { sweetAlert } from 'src/app/utils/swal';
import { allowOnlyNumbersValidator, onTimeChange, phoneNumberLengthValidator, timeZone } from 'src/app/utils/utils.common';
import { addressValidator } from 'src/app/utils/custom-validators';
import { PrimaryDiagnosisService } from 'src/app/services/core/primary-diagnosis/primary-diagnosis.service';
import { ModifierCodeService } from 'src/app/services/core/modifier-code/modifier-code.service';
@UntilDestroy()
@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-create-trip',
  templateUrl: './create-trip.component.html',
  styleUrls: ['./create-trip.component.css'],

})


export class CreateTripComponent implements OnInit {
  addMemberModalObj = false;
  addonsList: any = [];
  levelOfServiceList: any = [];
  preLevelOfServiceList: any = [];
  memberList: any = [];
  selectedMember: any = '';
  modifierList: any = [];
  newTripForm!: FormGroup;
  spaceTypeList: any = [];
  spaceTypeMainList: any = [];
  preSpaceTypeList: any = [];
  preAppointmentTypes: any = {};
  submitted = false;
  tripPurposeList: any = [];
  appointmentTypes: any = [];
  user: any;
  todayDate: any;
  tripId: any;
  stagingTripId: any;
  StandingOrderId: any
  addMember: boolean = false;
  timeZone = timeZone;
  selectedDay: any = [];
  fundingSourceList: any = [];
  preFundingSource: any = {}
  serviceAreaList: any = [];
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  companies: any
  preCompanies: any
  placetypes: any;
  calculateFare: boolean = false;
  enableFareCalculation: boolean = false
  fareLoading: boolean = false;
  isWillCall: boolean[] = [];
  private readonly memberSearchSubject = new Subject<string | undefined>();
  memberSearchQuery: any;
  @Input() isFromStandingOrder: any
  @Input() standingOrderId: any
  @Output() dataLoaded = new EventEmitter<void>();
  preferedTps: any = [];
  userPermission = UserPermission;
  fareDetails: any;
  menuSection: any;
  specialFareTotal: number = 0;
  preSpecialFareTotal: number = 0;

  legFareEstimation: any = [];
  preSpaceTypeFares: any = {};
  primaryDiagnosisList:any;
  modifierCodeList: any;

  constructor(
    private fb: FormBuilder,
    private uploadService: UploadService,
    private sharedDataService: SharedDataService,
    private SpaceTypeService: SpaceTypeService,
    private levelOfService: LosService,
    private memberService: MemberService,
    private tripService: TripService,
    private router: Router,
    private appointmentType: AppointmentTypeService,
    private addonService: AddonService,
    private serviceArea: ServiceAreasService,
    private fundingSource: FundingSourceService,
    private activatedRoute: ActivatedRoute,
    private placetypesService: PlacetypesService,
    private credentialService: CredentialService,
    private cdr: ChangeDetectorRef,
    public permissionService: PermissionService,
    private stagingTripService: StagingTripService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
    private modifierCodeService: ModifierCodeService,
  ) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as { isFromStandingOrder: boolean; section?: string; };
    if (state?.isFromStandingOrder) {
      this.isFromStandingOrder = state?.isFromStandingOrder
    }
    if (state?.section) {
      this.menuSection = state.section;
    }
  }

  get form() {
    return this.newTripForm.controls;
  }

  get pickUpForm() {
    return this.newTripForm.controls.pickup as FormGroup;
  }

  get dropOffForm() {
    return this.newTripForm.controls.destination as FormGroup;
  }

  get addonsForm(): FormArray {
    return this.newTripForm.get('addons') as FormArray;
  }

  get addonsFormGroups(): FormGroup[] {
    return this.addonsForm.controls as FormGroup[];
  }

  get attachmentForm() {
    return this.newTripForm.get('attachments') as FormArray;
  }

  get attachmentFormGroups(): FormGroup[] {
    return this.attachmentForm.controls as FormGroup[];
  }

  get legForm() {
    return this.newTripForm.get('legs') as FormArray;
  }
  get flagForm() {
    return this.newTripForm.get('flags') as FormGroup;
  }

  get legFormGroups(): FormGroup[] {
    return this.legForm.controls as FormGroup[];
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
      if (params && params['stagingTripId']) {
        this.stagingTripId = params['stagingTripId'];
      }
    });

    this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
      if (param && param['tripId'])
        this.tripId = param['tripId']
      this.StandingOrderId = param['standingOrderId']
    })

    this.newTripForm = this.createForm();
    this.makeCompulsoryCalls();
    this.listenMemberSearch();

    if (!this.tripId) {
      this.getAllMembers();
    }

    const watchFareControls = (controls: AbstractControl[]) => {
      controls.forEach(control => {
        control.valueChanges
          .pipe(
            debounceTime(500),
            untilDestroyed(this)
          )
          .subscribe(() => {
            const parent = control.parent as FormGroup;
            if (!parent) return;

            const controlName = Object.keys(parent.controls)
              .find(name => control === parent.controls[name]);

            if (!controlName) return;

            if (controlName === 'miles') {
              const milesValue = Number(control.value);
              if (isNaN(milesValue) || milesValue < 0) return;
            }
            if (controlName === 'addons') {
              const addons = control.value.filter((item: any) => item.addon)
              if (!addons.length) return;
            }
            this.fareEstimation()
          });
      });
    };

    watchFareControls(
      [
        this.newTripForm.get('fundingsource'),
        this.newTripForm.get('spaceType'),
        this.newTripForm.get('levelOfService'),
        this.pickUpForm.get('pickup.address.coords'),
        this.newTripForm.get('destination.address.coords'),
        this.newTripForm.get('miles'),
        this.newTripForm.get('addons'),
        this.newTripForm.get('pickup.time'),
      ].filter((c): c is AbstractControl => c !== null)
    );

    this.watchSpecialRates(this.newTripForm);
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).pipe(untilDestroyed(this)).subscribe(
      ([res1, res2]) => {
        if (res2) {
          this.spaceTypeMainList = res2.filter((spaceType: any) => spaceType.isActive === true);
          this.preSpaceTypeList = this.spaceTypeMainList.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
        if (res1) {
          const activeSpaceTypeLosIds = this.spaceTypeMainList
            .filter((spaceType: any) => spaceType.isActive)
            .map((spaceType: any) => spaceType.los);
          this.levelOfServiceList = res1.filter((los: any) => los.isActive === true);

          this.levelOfServiceList = res1.filter((los: any) => los.isActive && activeSpaceTypeLosIds.includes(los.id)
          );
          this.preLevelOfServiceList = this.levelOfServiceList.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
        this.getUser();
        // Rest API calls here
        this.getServiceArea();
        this.getFundingSource();
        this.getAppointmentTypes();
        // this.getAllCompanies();
        this.getPlaceTypes();
        this.getAllAddons();
        this.getPrimaryDiagnosis();
        this.getModifierCodes();


        if (this.tripId) {
          this.getTripDetails();
        }
        if (this.standingOrderId) {
          this.getStandingOrderDetails();
        }
        if (this.stagingTripId) {
          this.getStagingTripDetails();
        }
        this.dataLoaded.emit();
      },
      (error: any) => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getTripDetails() {
    this.tripService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {

        if (this.tripId) {
          this.getMemberById(data.member)
        }

        this.newTripForm.patchValue({
          ...data,
          pickup: data.pickup,
          destination: data.destination,
          additionalPassenger: data.additionalPassenger ?? '',
        });
        this.addAttachment(data.attachments);
        this.onSelectLOS(data.levelOfService);
        this.addAddonsItem(data.addons);
        if (data.fundingsource) {
          this.getFaresByFundingSource(data.fundingsource);
        }
        this.memberSearch(null, data.member);
        this.enableFareCalculation = true;

      }
    })
  }

  getStandingOrderDetails() {
    this.tripService.getStandingorderById(this.standingOrderId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.getMemberById(data.member.id);
        if (data.fundingsource) {
          this.getFaresByFundingSource(data.fundingsource);
        }
        this.enableFareCalculation = true;
      }
    });
  }

  getStagingTripDetails() {
    this.stagingTripService.getTripById(this.stagingTripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (data.member) {
          this.getMemberById(data.member);
        }

        this.newTripForm.patchValue({
          ...data,
          pickup: data.pickup,
          destination: data.destination,
        });

        // Handle LOS and Space Type
        if (data.levelOfService) {
          this.onSelectLOS(data.levelOfService);
        }
        if (data.fundingsource) {
          this.getFaresByFundingSource(data.fundingsource);
        }
        this.memberSearch(null, data.member);
        this.enableFareCalculation = true;
      }
    });
  }

  getMemberById(id: any) {
    this.memberService.getPickerMembers({ id: id }).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        [this.selectedMember] = data.results;
        if (this.selectedMember && this.selectedMember.prefferedTP) {
          this.preferedTps = this.selectedMember.prefferedTP;
          if (this.preferedTps && this.preferedTps.length) {
            this.getAllCompanies();
          }
        }
      }
    })
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.timeZone = data.timeZone
        this.todayDate = moment().tz(this.timeZone).toISOString();
        this.newTripForm.patchValue({
          pickup: { time: this.todayDate },
          destination: { time: moment(this.todayDate).add(1, 'hours').toISOString() },
        });
      }

    })
  }

  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
    }

    if (!this.tripId) {
      queryParams.isActive = true;
    }

    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.memberList = [...this.memberList, ...data.results];
        this.memberPageNumber += 1;
      }
    })
  }
  getServiceArea() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.serviceArea.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.serviceAreaList = data.results;
      }
    })
  }

  getFundingSource() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.fundingSource.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.fundingSourceList = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
        this.preFundingSource = this.fundingSourceList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getPlaceTypes() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.placetypesService.getPickers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.placetypes = data.results;
      }
    })
  }

  getLevelOfService() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    return this.levelOfService.getPicker(queryParams).pipe(
      map((res: any) => res.results || [])
    );
  }

  getSpaceTypeList() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    return this.SpaceTypeService.getPicker(queryParams).pipe(
      map((res: any) => res.results || [])
    );
  }

  getAllAddons() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.addonService.getPickerAddons(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.addonsList = data.results.filter((addons: any) => addons.isActive === true);

      }
    })
  }


  onCreateTrip() {
    this.submitted = true;
    if (this.newTripForm.invalid) return;

    const payload = this.newTripForm.value;
    if (this.stagingTripId) {
      payload.stagingTrip = this.stagingTripId;
      const rawForm = this.newTripForm.getRawValue();
      if (rawForm && rawForm.suffix) {
        payload.suffix = rawForm.suffix;
      }
    }
    if (payload.pickup.phoneNumber === '') {
      delete payload.pickup.phoneNumber
    }
    if (payload.destination.phoneNumber === '') {
      delete payload.destination.phoneNumber
    }
    if (payload.serviceArea === '') {
      delete payload.serviceArea
    }
    if (payload.legs && Array.isArray(payload.legs)) {
      payload.legs.forEach((leg: any) => {
        if (!leg.pickup.phoneNumber) delete leg.pickup.phoneNumber;
        if (!leg.destination.phoneNumber) delete leg.destination.phoneNumber;
        if (!leg.serviceArea) delete leg.serviceArea;
      });
    }
    this.tripService.createTrip(payload, this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (this.stagingTripId) {
          this.stagingTripService.updateTrip({ status: 'created' }, this.stagingTripId).subscribe((data) => {
            if (data) { 
              this.router.navigateByUrl('/trips/staging')
            }
          });
        } else {
          this.router.navigate(['trips'], { fragment: this.tripId ? (this.menuSection || data.status) : 'scheduled' });
        }
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    }
    );
  }


  onSelectLOS(losId: any) {
    losId = (typeof losId === 'object' && losId !== null) ? losId.id : losId;
    if (!losId) {
      this.spaceTypeList = [];
      this.newTripForm.patchValue({ spaceType: '' });
      return;
    }
    this.spaceTypeList = this.spaceTypeMainList.filter((item: any) => item.los === losId);
    if (!this.spaceTypeList.some((item: any) => item.id === this.newTripForm.value.spaceType)) {
      this.newTripForm.patchValue({ spaceType: '' });
    }
  }

  onSelectFundingSource(evt: any) {
    if (evt) {
      this.getFaresByFundingSource(evt);
    }
  }

  getFaresByFundingSource(fundingSourceId: string) {
    this.preSpaceTypeFares = {};
    this.credentialService.getfundingSourceFares(fundingSourceId, { limit: 9999, isActive: true }).subscribe((res: any) => {
      this.preSpaceTypeFares = (res?.results || []).reduce((obj: any, item: any) => {
        obj[item.spaceType] = item;
        return obj;
      }, {});
    }, (err: any) => {
      sweetAlert('Error', err, 'error', 'Ok');
    });
  }

  onSelectMember(event: any) {
    if (typeof event === 'string') {
      this.selectedMember = event ? this.memberList.find((m: any) => m.id === event) : null;
      this.preferedTps = this.selectedMember.prefferedTP
      if (this.preferedTps && this.preferedTps.length) {
        this.getAllCompanies();
      }
    } else {
      this.selectedMember = event ? this.memberList.find((m: any) => m.id === event.id) : null;
    }
    if (!this.selectedMember) {
      this.clearMemberData();
      return;
    }
    const memberFundingSourceId = (this.selectedMember.fundingSource ? this.selectedMember?.fundingSource : this.selectedMember.fundingsource) || ''
    if (this.selectedMember) {
      this.newTripForm.patchValue({
        ...this.selectedMember,
        fundingsource: this.preFundingSource[memberFundingSourceId] ? memberFundingSourceId : '',
        pickup: {
          phoneNumber: this.selectedMember.contactNumber,
          address: this.selectedMember.address
        }
      })
      const pickupCoords = this.pickUpForm.get('address.coords')?.value;
      const destinationCoords = this.dropOffForm.get('address.coords')?.value;
      if (pickupCoords?.length && destinationCoords?.length) {
        this.calculateMiles();
      }
      if (memberFundingSourceId) {
        this.getFaresByFundingSource(memberFundingSourceId);
      }
      if (!this.selectedMember.levelOfService) {
        this.newTripForm.patchValue({
          levelOfService: ''
        });
      }
      const matchedServiceArea = this.serviceAreaList?.find((area: any) => {
        return area.zipCodes.includes(this.selectedMember?.address?.zipCode);
      });
      this.newTripForm.patchValue({
        serviceArea: matchedServiceArea ? matchedServiceArea.id : ''
      });
      this.onSelectLOS(this.selectedMember.levelOfService)
    } else {
      this.newTripForm.patchValue({
        member: '',
        pickup: {
          time: '',
          placeName: '',
          phoneNumber: '',
          address: {
            name: '',
            coords: '',
            city: '',
            state: '',
            zipCode: '',
            floor: '',
            aptSuiteRoom: '',
          }
        },
        appointmentType: '',
        levelOfService: '',
        spaceType: '',
        privateNotes: '',
        generalNotes: '',
      });
    }
  }

  clearMemberData() {
    this.newTripForm.patchValue({
      member: '',
      fundingsource: '',
      serviceArea: '',
      pickup: {
        placeName: '',
        phoneNumber: '',
        address: {
          name: '',
          coords: '',
          city: '',
          state: '',
          zipCode: '',
          floor: '',
          aptSuiteRoom: '',
        }
      },
      miles: '',
      appointmentType: '',
      levelOfService: '',
      spaceType: '',
      privateNotes: '',
      generalNotes: '',
    });
    this.selectedMember = null;
  }


  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null);
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onSelectAddonItem(addonItem: any) {
    if (!addonItem.value.addon || !addonItem.value.quantity) return;

    const item = this.addonsList.find((item: any) => item._id === addonItem.value.addon);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  quantityGreaterThanZero(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const numberValue = Number(value);
    return numberValue > 0 ? null : { greaterThanZero: true };
  }


  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addons') as FormArray;
    items.removeAt(index);
    this.fareEstimation();
  }

  addAddonsItem(preAddonList?: any) {
    const items = this.newTripForm.get('addons') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addon: [addon.addon, Validators.required],
            quantity: [addon.quantity, [Validators.required, this.quantityGreaterThanZero]],
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addon: ['', Validators.required],
        quantity: [1, [Validators.required, this.quantityGreaterThanZero]],
      })
    );
    // }
  }

  public createForm(): FormGroup {
    return this.fb.group({
      member: ['', Validators.required],
      primaryDiagnosis:[''],
      pickup: this.fb.group({
        time: ['', Validators.required],
        placeName: [''],
        phoneNumber: ['', [phoneNumberLengthValidator]],
        modifier: [''],
        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[]],
          city: [''],
          state: [''],
          zipCode: [''],
          floor: [''],
          aptSuiteRoom: [''],
        }, { validators: addressValidator() })
      }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
      destination: this.fb.group({
        time: ['', Validators.required],
        placeName: [''],
        phoneNumber: ['', [phoneNumberLengthValidator]],
        modifier: [''],
        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[]],
          city: [''],
          state: [''],
          zipCode: [''],
          floor: [''],
          aptSuiteRoom: [''],
        }, { validators: addressValidator() })
      }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
      appointmentType: [''],
      levelOfService: ['', Validators.required],
      spaceType: ['', Validators.required],
      miles: [''],
      additionalPassenger: [''],
      privateNotes: [''],
      generalNotes: [''],
      requesterName: [''],
      attachments: this.fb.array([]),
      reference: [''],
      suffix: [{ value: '', disabled: true }],
      legs: this.fb.array([]),
      addons: this.fb.array([]),
      fundingsource: ['', Validators.required],
      serviceArea: ['', Validators.required],
      billingNotes: [''],
      specialRate: [0],
      preSpecialRate: [0],
      flags: this.fb.group({
        isEstimation: [false],
      })
    });
  }

  setOriginAddress(place: any, index?: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';
    const matchedServiceArea = this.serviceAreaList?.find((area: any) => {
      return area.zipCodes.includes(zip);
    });
    if (index != 0) {
      this.newTripForm.patchValue({
        serviceArea: matchedServiceArea ? matchedServiceArea.id : ''
      });
    }

    if (index > -1) {
      const items = this.newTripForm.get('legs') as FormArray;
      items.at(index).patchValue({
        serviceArea: matchedServiceArea ? matchedServiceArea.id : '',
        pickup: {
          address: {
            city: cityName,
            state: stateName,
            zipCode: zip,
            name: place.formatted_address,
            coords: [
              place.geometry.location.lng(),
              place.geometry.location.lat()
            ]
          }
        }
      });
    } else {
      this.newTripForm.patchValue({
        pickup: {
          address: {
            city: cityName,
            state: stateName,
            zipCode: zip,
            name: place.formatted_address,
            coords: [
              place.geometry.location.lng(),
              place.geometry.location.lat()
            ]
          }
        }
      });
    }
    this.calculateMiles(index);
  }

  onChangeOriginAddress(index?: any) {
    if (index > -1) {
      const items = this.newTripForm.get('legs') as FormArray;
      items.at(index).patchValue({
        serviceArea: '',
        pickup: {
          address: {
            coords: '',
            city: '',
            state: '',
            zipCode: '',
          }
        }
      });
    } else {
      this.newTripForm.patchValue({
        pickup: {
          address: {
            coords: '',
            city: '',
            state: '',
            zipCode: '',
          }
        }
      });
    }
  }

  setDestinationAddress(place: any, index?: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    // const zip = selectedAddress.zipCode;
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';

    if (index > -1) {
      const items = this.newTripForm.get('legs') as FormArray;
      items.at(index).patchValue({
        destination: {
          address: {
            city: cityName,
            state: stateName,
            zipCode: zip,
            name: place.formatted_address,
            coords: [
              place.geometry.location.lng(),
              place.geometry.location.lat()
            ]
          }
        }
      })
    } else {
      this.newTripForm.patchValue({
        destination: {
          address: {
            city: cityName,
            state: stateName,
            zipCode: zip,
            name: place.formatted_address,
            coords: [
              place.geometry.location.lng(),
              place.geometry.location.lat()
            ]
          }
        }
      });
    }
    this.calculateMiles(index);
  }

  onChangeDestinationAddress(index?: any) {
    if (index > -1) {
      const items = this.newTripForm.get('legs') as FormArray;
      items.at(index).patchValue({
        destination: {
          address: {
            coords: '',
            city: '',
            state: '',
            zipCode: ''
          }
        }
      });
    } else {
      this.newTripForm.patchValue({
        destination: {
          address: {
            coords: '',
            city: '',
            state: '',
            zipCode: '',
          }
        }
      });
    }
  }

  onPickupDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
    this.newTripForm.patchValue({
      destination: {
        time: moment(controlName?.value).add(1, 'hour').toISOString()
      }
    })
  }
  onLegPickUpDateChange(group: any, controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
    group.patchValue({
      destination: {
        time: moment(controlName?.value).add(1, 'hour').toISOString()
      }
    })
  }
  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  getAppointmentTypes() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.appointmentType.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentTypes = data.results
        this.preAppointmentTypes = this.appointmentTypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getAllCompanies() {
    let queryParams = {
      limit: 9999,
      id: this.preferedTps ? this.preferedTps : '',
      isActive: true,
    }
    this.credentialService.getPicker(queryParams)
      .subscribe((data: any) => {
        if (data && data.results) {
          this.companies = data.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  addAttachment(preAttachments?: any) {
    const attachments = this.newTripForm.get('attachments') as FormArray;
    if (preAttachments) {
      for (const attachment of preAttachments) {
        attachments.push(
          this.fb.group({
            filename: [attachment.filename, Validators.required],
            url: [attachment.url, Validators.required],
            mimeType: [attachment.mimeType],
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    attachments.push(
      this.fb.group({
        filename: ['', Validators.required],
        url: ['', Validators.required],
        mimetype: [''],
      })
    );
  }

  uploadAttachment(event: any) {
    const fileInput = event.target
    this.uploadService.uploadTripAttachment(event.target.files[0]).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        const file = event.target.files[0];
        if (file) {
          const fileData = {
            filename: file.name,
            mimeType: file.type,
            url: data.fileUrl
          };
          this.attachmentForm.push(this.fb.control(fileData));
        }
        fileInput.value = '';
      }
    })
  }

  removeAttachment(index: number) {
    this.attachmentForm.removeAt(index);
  }

  addLegItem() {
    const items = this.newTripForm.get('legs') as FormArray;
    const legCount = items.length;
    let preValues;

    if (legCount === 0) {
      preValues = this.newTripForm.value;
    } else {
      preValues = items.at(legCount - 1).value;
    }

    const preIsWillCall = this.isWillCall[legCount - 1];
    const lastDestinationTime = preValues.destination?.time
      ? (preIsWillCall
        ? moment(preValues.destination.time)
        : moment(preValues.destination.time).add(1, 'hour'))
      : moment().add(1, 'hour');

    const newPickupTime = lastDestinationTime.toISOString();
    const newDestinationTime = preIsWillCall
      ? newPickupTime
      : lastDestinationTime.add(1, 'hour').toISOString();

    let newLeg: FormGroup;

    // --- LEG 2 ---
    if (legCount === 0) {
      const tripValues = this.newTripForm.value;
      newLeg = this.fb.group({
        serviceArea: [tripValues.serviceArea, Validators.required],
        miles: [tripValues.miles],
        preSpecialRate:[0],
        specialRate: [0],
        privateNotes: [tripValues.privateNotes],
        generalNotes: [tripValues.generalNotes],
        pickup: this.fb.group({
          time: [newPickupTime, Validators.required],
          placeName: [tripValues.destination.placeName],
          phoneNumber: [tripValues.destination.phoneNumber, [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [tripValues.destination.address.name, Validators.required],
            coords: [tripValues.destination.address.coords],
            city: [tripValues.destination.address.city],
            state: [tripValues.destination.address.state],
            zipCode: [tripValues.destination.address.zipCode],
            floor: [tripValues.destination.address.floor],
            aptSuiteRoom: [tripValues.destination.address.aptSuiteRoom],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
        destination: this.fb.group({
          time: [newDestinationTime, Validators.required],
          placeName: [tripValues.pickup.placeName],
          phoneNumber: [tripValues.pickup.phoneNumber, [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [tripValues.pickup.address.name, Validators.required],
            coords: [tripValues.pickup.address.coords],
            city: [tripValues.pickup.address.city],
            state: [tripValues.pickup.address.state],
            zipCode: [tripValues.pickup.address.zipCode],
            floor: [tripValues.pickup.address.floor],
            aptSuiteRoom: [tripValues.pickup.address.aptSuiteRoom],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
      });

      // --- LEG 3 ---
    } else if (legCount === 1) {
      const leg2 = items.at(0) as FormGroup;

      // create new leg (both pickup + destination empty)
      newLeg = this.fb.group({
        serviceArea: [leg2.get('serviceArea')?.value, Validators.required],
        miles: [''],
        preSpecialRate:[0],
        specialRate: [0],
        privateNotes: [leg2.get('privateNotes')?.value],
        generalNotes: [leg2.get('generalNotes')?.value],
        pickup: this.fb.group({
          time: [newPickupTime, Validators.required],
          placeName: [leg2.get('destination.placeName')?.value],
          phoneNumber: [leg2.get('destination.phoneNumber')?.value, [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [leg2.get('destination.address.name')?.value, Validators.required],
            coords: [leg2.get('destination.address.coords')?.value],
            city: [leg2.get('destination.address.city')?.value],
            state: [leg2.get('destination.address.state')?.value],
            zipCode: [leg2.get('destination.address.zipCode')?.value],
            floor: [leg2.get('destination.address.floor')?.value],
            aptSuiteRoom: [leg2.get('destination.address.aptSuiteRoom')?.value],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
        destination: this.fb.group({
          time: [newDestinationTime, Validators.required],
          placeName: [''],
          phoneNumber: ['', [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: ['', Validators.required],
            coords: [''],
            city: [''],
            state: [''],
            zipCode: [''],
            floor: [''],
            aptSuiteRoom: [''],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
      });

      // --- LEG 4 ---
    } else if (legCount === 2) {
      const leg1 = this.newTripForm.value;
      const leg3 = items.at(1).value;

      newLeg = this.fb.group({
        serviceArea: [leg1.serviceArea, Validators.required],
        miles: [''],
        preSpecialRate:[0],
        specialRate: [0],
        privateNotes: [leg1.privateNotes],
        generalNotes: [leg1.generalNotes],
        pickup: this.fb.group({
          time: [newPickupTime, Validators.required],
          placeName: [leg3.destination?.placeName || ''],
          phoneNumber: [leg3.destination?.phoneNumber || '', [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [leg3.destination?.address?.name || '', Validators.required],
            coords: [leg3.destination?.address?.coords || ''],
            city: [leg3.destination?.address?.city || ''],
            state: [leg3.destination?.address?.state || ''],
            zipCode: [leg3.destination?.address?.zipCode || ''],
            floor: [leg3.destination?.address?.floor || ''],
            aptSuiteRoom: [leg3.destination?.address?.aptSuiteRoom || ''],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
        destination: this.fb.group({
          time: [newDestinationTime, Validators.required],
          placeName: [leg1.pickup.placeName],
          phoneNumber: [leg1.pickup.phoneNumber, [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [leg1.pickup.address.name, Validators.required],
            coords: [leg1.pickup.address.coords],
            city: [leg1.pickup.address.city],
            state: [leg1.pickup.address.state],
            zipCode: [leg1.pickup.address.zipCode],
            floor: [leg1.pickup.address.floor],
            aptSuiteRoom: [leg1.pickup.address.aptSuiteRoom],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
      });

    } else {
      // Fallback logic for extra legs
      newLeg = this.fb.group({
        serviceArea: [preValues.serviceArea, Validators.required],
        miles: [preValues.miles],
        preSpecialRate: [0],
        specialRate: [0],
        privateNotes: [preValues.privateNotes],
        generalNotes: [preValues.generalNotes],
        pickup: this.fb.group({
          time: [newPickupTime, Validators.required],
          placeName: [preValues.destination.placeName],
          phoneNumber: [preValues.destination.phoneNumber, [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [preValues.destination.address.name, Validators.required],
            coords: [preValues.destination.address.coords],
            city: [preValues.destination.address.city],
            state: [preValues.destination.address.state],
            zipCode: [preValues.destination.address.zipCode],
            floor: [preValues.destination.address.floor],
            aptSuiteRoom: [preValues.destination.address.aptSuiteRoom],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
        destination: this.fb.group({
          time: [newDestinationTime, Validators.required],
          placeName: [preValues.pickup.placeName],
          phoneNumber: [preValues.pickup.phoneNumber, [phoneNumberLengthValidator]],
          modifier: [''],
          address: this.fb.group({
            name: [preValues.pickup.address.name, Validators.required],
            coords: [preValues.pickup.address.coords],
            city: [preValues.pickup.address.city],
            state: [preValues.pickup.address.state],
            zipCode: [preValues.pickup.address.zipCode],
            floor: [preValues.pickup.address.floor],
            aptSuiteRoom: [preValues.pickup.address.aptSuiteRoom],
          }, { validators: addressValidator() }),
        }, { validators: allowOnlyNumbersValidator('phoneNumber') }),
      });
    }

    items.push(newLeg);


    const watchFareControls = (controls: AbstractControl[]) => {
      controls.forEach(control => {
        control.valueChanges
          .pipe(
            debounceTime(500),
            untilDestroyed(this)
          )
          .subscribe(() => {
            const parent = control.parent as FormGroup;
            if (!parent) return;

            const controlName = Object.keys(parent.controls)
              .find(name => control === parent.controls[name]);

            if (!controlName) return;

            if (controlName === 'miles') {
              const milesValue = Number(control.value);
              if (isNaN(milesValue) || milesValue < 0) return;
            }
            const currentIndex = items.controls.indexOf(newLeg);
            if (currentIndex !== -1) {
              this.legFareEstimationCall(newLeg, currentIndex);
            }
          });
      });
    };





    watchFareControls(
      [
        this.newTripForm.get('fundingsource'),
        this.newTripForm.get('spaceType'),
        this.newTripForm.get('levelOfService'),
        newLeg.get('pickup.address.coords'),
        newLeg.get('destination.address.coords'),
        newLeg.get('miles'),
        this.newTripForm.get('addons'),
        newLeg.get('pickup.time'),
      ].filter((c): c is AbstractControl => c !== null)
    );

    // finally add the leg
    this.legFareEstimationCall(newLeg, items.length - 1)
    this.isWillCall.push(false);
    this.calculateMiles(items.length - 1);


    // propagate will call if previous was true
    if (this.isWillCall.length && this.isWillCall[this.isWillCall.length - 2]) {
      this.isWillCall[this.isWillCall.length - 1] = true;
      this.setWillCall({ target: { checked: true } }, this.isWillCall.length - 1);
    }


    this.watchSpecialRates(newLeg)
  }

  removeLegItem(index: any) {
    const items = this.newTripForm.get('legs') as FormArray;
    items.removeAt(index);
    this.isWillCall.splice(index, 1);
    this.legFareEstimation.splice(index, 1);
    this.calculateSpecialFaresTotal();
  }

  openAddMemberModal() {
    this.addMember = true;
  }

  onSaveMember(evt: any) {
    if (evt && this.memberList && this.memberList.length) {
      // Update existing member in the list
      const index = this.memberList.findIndex((member: any) => member.id === evt.id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }

      // Update the form with new member details
      this.newTripForm.patchValue({
        member: evt.id
      });
      this.onSelectMember(evt);

      this.addMemberModalObj = false;

      // Refresh the dropdown by triggering change detection
    }


  }


  calculateMiles(index?: number) {
    let queryParam;
    let startCoords: any = [];
    let endCoords: any = [];

    if (index !== undefined && index > -1) {
      const items = this.newTripForm.get('legs') as FormArray;
      const legControl = items.at(index) as FormGroup;

      if (legControl) {
        startCoords = legControl.get('pickup.address.coords')?.value || [];
        endCoords = legControl.get('destination.address.coords')?.value || [];
      }
    } else {
      startCoords = this.pickUpForm.value.address.coords;
      endCoords = this.dropOffForm.value.address.coords;
    }

    if (startCoords.length && endCoords.length) {
      queryParam = {
        start: [startCoords[0], startCoords[1]].toString(),
        end: [endCoords[0], endCoords[1]].toString(),
      };

      this.fareLoading = true;
      this.enableFareCalculation = false;
      this.cdr.detectChanges();
      this.tripService
        .calculateMiles(queryParam)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.enableFareCalculation = true;
              this.fareLoading = false;
              this.cdr.detectChanges();
              const firstSegment =
                data.features[0]?.properties?.segments[0]?.distance || 0;
              const milesValue = Number((firstSegment / 1609.344).toFixed(2));

              if (index !== undefined && index > -1) {
                const items = this.newTripForm.get('legs') as FormArray;
                items.at(index).patchValue({ miles: roundUp(milesValue) });
              } else {
                this.newTripForm.patchValue({ miles: roundUp(milesValue) });
              }
            }
          },
          error: (err) => {
            this.enableFareCalculation = false;
            this.fareLoading = false; //
            this.cdr.detectChanges();
            sweetAlert('Error', 'Invalid Address', 'error', 'Ok');
          },
          complete: () => {
            // optional: code to run after the observable completes
          },
        });
    }
  }


  onScroll() {
    if (this.memberSearchQuery) {
      this.memberSearch(this.memberSearchQuery);
    } else {
      this.getAllMembers();
    }
  }

  onSearch(event: any) {
    const { term } = event;
    if (term) {
      this.memberSearchSubject.next(term);
    } else {
      this.clearSearh();
    }
  }

  listenMemberSearch() {
    this.memberSearchSubject
      .pipe(debounceTime(1000))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.memberSearchQuery = search;
        if (search && search.length >= 3) {
          this.memberList = [];
          this.memberSearchPageNumber = 1;
          this.memberSearch(search);
        }
      });
  }

  memberSearch(search: any, id = null) {
    const queryParams: any = {
      limit: 10,
      page: this.memberSearchPageNumber
    }

    if (search) {
      queryParams.search = search;
    }

    if (id) {
      queryParams.id = id;
    }

    if (!this.tripId) {
      queryParams.isActive = true;
    }

    this.memberService.searchMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.memberList = [...this.memberList, ...data.results];
        this.memberSearchPageNumber += 1;
      }
    });
  }


  setWillCall(event: any, index: number) {
    if (index !== -1) {
      const legsFormArray = this.newTripForm.get('legs') as FormArray;
      const legGroup = legsFormArray.at(index) as FormGroup;

      const pickupTimeControl = legGroup.get('pickup.time');
      const destinationTimeControl = legGroup.get('destination.time');

      if (event.target.checked) {
        const existingPickup = pickupTimeControl?.value;
        if (existingPickup) {
          const pickupMoment = moment(existingPickup).tz(this.timeZone);
          pickupMoment.set('hour', 23).set('minute', 59);
          pickupTimeControl?.setValue(pickupMoment);
          const dropoffMoment = moment(existingPickup).tz(this.timeZone);
          dropoffMoment.set('hour', 23).set('minute', 59);
          destinationTimeControl?.setValue(dropoffMoment);
        }
      }
    } else {
      const pickupTimeControl = this.newTripForm.get('pickup.time');
      const destinationTimeControl = this.newTripForm.get('destination.time');

      if (event.target.checked) {
        const existingPickup = pickupTimeControl?.value;
        if (existingPickup) {
          const pickupMoment = moment(existingPickup).tz(this.timeZone);
          pickupMoment.set('hour', 23).set('minute', 59);
          pickupTimeControl?.setValue(pickupMoment);
          const dropoffMoment = moment(existingPickup).tz(this.timeZone);
          dropoffMoment.set('hour', 23).set('minute', 59);
          destinationTimeControl?.setValue(dropoffMoment);
        }
      }
    }

  }


  onClear() {
    if (this.memberSearchQuery) {
      this.clearSearh();
      this.clearMemberData();
    }
  }

  clearSearh() {
    this.memberSearchQuery = '';
    this.memberSearchPageNumber = 1;
    this.memberList = [];
    this.memberPageNumber = 1
    this.getAllMembers();
  }

  onClose() {
    if (!this.selectedMember && this.memberSearchQuery) {
      this.clearSearh();
    }
  }

  toggleFareModal() {
    this.calculateFare = !this.calculateFare;
  }

  closeFareModal() {
    this.calculateFare = false;
  }


  fareEstimation() {
    const fundingSourceValue = this.newTripForm.get('fundingsource')?.value;
    const pickupCoords = this.pickUpForm.get('address')?.value?.coords;
    const destCoords = this.newTripForm.get('destination')?.value?.address?.coords;
    const levelOfService = this.newTripForm.get('levelOfService')?.value;
    const spaceType = this.newTripForm.get('spaceType')?.value;

    // ✅ If any required values are missing, don't call API.
    if (!pickupCoords || pickupCoords.length < 2 || !destCoords || destCoords.length < 2 || !fundingSourceValue || !levelOfService || !spaceType) {
      this.fareDetails = null;
      return;
    }
    let addons = this.newTripForm.value.addons.filter((item: any) => item.addon)



    const trip: any = {
      pickup: { time: this.newTripForm.get('pickup')?.value?.time, address: { coords: pickupCoords } },
      destination: { address: { coords: destCoords } },
      levelOfService: levelOfService || null,
      spaceType: spaceType || null,
      addons: addons
    };
    const miles = parseFloat(this.newTripForm.value.miles); 
    if (!isNaN(miles) && miles >= 0) {
      trip.miles = miles;
    }

    // if (addons && addons.length) {
    //   trip.addons = addons;
    // }


    const payload: any = {
      trips: [trip],
      fundingsource: fundingSourceValue || null,
    };

    this.tripService.calculateFare(payload).subscribe({
      next: (response: any) => {
        this.fareDetails = response[0]?.breakdown || {};
      },
      error: () => {
        sweetAlert('Error', 'Failed to calculate fare', 'error', 'Ok');
      },
    });
  }

  legFareEstimationCall(leg: any, index: number) {
    const fundingSourceValue = this.newTripForm.get('fundingsource')?.value;
    const pickupCoords = leg.get('pickup')?.value?.address.coords;
    const destCoords = leg.get('destination')?.value?.address?.coords;
    const levelOfService = this.newTripForm.get('levelOfService')?.value;
    const spaceType = this.newTripForm.get('spaceType')?.value;
    if (!pickupCoords || pickupCoords.length < 2 || !destCoords || destCoords.length < 2 || !fundingSourceValue || !levelOfService || !spaceType) {
      this.legFareEstimation[index] = null;
      return;
    }


    let addons = this.newTripForm.value.addons.filter((item: any) => item.addon);
    const trip: any = {
      pickup: { time: leg.get('pickup')?.value?.time, address: { coords: pickupCoords } },
      destination: { address: { coords: destCoords } },
      levelOfService,
      spaceType,
      addons
    };
    const miles = parseFloat(leg.get('miles').value)
    if (!isNaN(miles) && miles >= 0) {
      trip.miles = miles;
    }
    const payload: any = {
      trips: [trip],
      fundingsource: fundingSourceValue,
    };

    this.tripService.calculateFare(payload).subscribe({
      next: (response: any) => {
        this.legFareEstimation[index] = response[0]?.breakdown || null;
      },
      error: () => {
        this.legFareEstimation[index] = null;
        sweetAlert('Error', 'Failed to calculate fare', 'error', 'Ok');
      },
    });
  }


  getSortedBreakdown(breakdown: any) {
    if (!breakdown) return [];

    const priority: Record<string, number> = {
      total: 0,
      baseFare: 1,
    };

    return Object.entries(breakdown)

      .sort(([keyA], [keyB]) => {
        const orderA = keyA in priority ? priority[keyA] : 2;
        const orderB = keyB in priority ? priority[keyB] : 2;
        return orderA - orderB;
      })
      .map(([key, value]) => ({
        key: this.formatKey(key),
        value
      }));
  }
  private formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')           // insert space before capital letters
      .replace(/^./, char => char.toUpperCase()); // capitalize first letter
  }

  formatValue(value: any) {
    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
      return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }

  grandTotal(legA: any): number {
    const legATotal = Number(legA?.total || 0);

    const legsTotal = (this.legFareEstimation || [])
      .filter((leg: any) => leg) // ignore nulls
      .reduce((sum: number, leg: any) => {
        const legTotal = Number(leg.total || 0);
        return sum + legTotal;
      }, 0);

    return (legATotal + legsTotal).toFixed(2);
  }

  private watchSpecialRates(control: AbstractControl) {
    control.get('preSpecialRate')?.valueChanges.subscribe(() => {
      this.calculateSpecialFaresTotal();
    });
    control.get('specialRate')?.valueChanges.subscribe(() => {
      this.calculateSpecialFaresTotal();
    });
   
  }

  calculateSpecialFaresTotal(): void {
   const preSpecialRate = Number(this.newTripForm.get('preSpecialRate')?.value || 0);

    const legsPreSpecialRate = this.legFormGroups.reduce((sum: number, leg: FormGroup) => {
      const preSpecialRate = Number(leg.get('preSpecialRate')?.value || 0);
      return sum + preSpecialRate;
    }, 0);

    this.preSpecialFareTotal = preSpecialRate + legsPreSpecialRate;
    const specialRate = Number(this.newTripForm.get('specialRate')?.value || 0);

    const legsSpecialRate = this.legFormGroups.reduce((sum: number, leg: FormGroup) => {
      const specialRate = Number(leg.get('specialRate')?.value || 0);
      return sum + specialRate;
    }, 0);

    this.specialFareTotal = specialRate + legsSpecialRate;
  }


    getPrimaryDiagnosis() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.primaryDiagnosisService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.primaryDiagnosisList = data.results;
        }
      })
  }

  getModifierCodes() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.modifierCodeService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.modifierCodeList = data.results;
        }
      })
  }
}
